var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrossIconSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.414 12L19 6.414l.778-2.192-2.192.777L12 10.586 6.414 4.998l-2.192-.777.777 2.191L10.586 12l-5.587 5.586-.777 2.192L6.414 19 12 13.414 17.586 19l2.192.778L19 17.586 13.414 12z",
    fill: "#9A9CAC"
  })));
}

export default SvgCrossIconSmall;